import { get, post } from "./divertidogsApiUtils";
import { MetodoPago } from "./ventasServicios";

export type CancelacionPreliminarGuarderia = {
    idAgendamiento: string,
    idVenta: string,
    // Fechas agendadas inicialmente
    fechasProgramadas: Array<string>,
    // Fechas en las que se le esperó asistencia a la mascota, consumiendo recursos
    fechasConsumidas: Array<string>,
    // Fechas en las que la mascota efectivamente estuvo en las instalaciones
    fechasAsistidas: Array<string>,
    // Fechas que serán canceladas en asistencia, aun no consumidas ni asistidas
    fechasCancelarAsistencia: Array<string>,
    fechasProgramadasTransporteIda: Array<string>,
    fechasConsumidasTransporteIda: Array<string>,
    fechasCancelarTransporteIda: Array<string>,
    fechasProgramadasTransporteVuelta: Array<string>,
    fechasConsumidasTransporteVuelta: Array<string>,
    fechasCancelarTransporteVuelta: Array<string>,
    // Valor total pactado de la reserva de guarderia
    totalReserva: number,
    // Valor total pagado (calculado) de la reserva de guarderia
    totalReservaTransporte: number,
    totalAgendamiento: number,
    descuento: number,
    totalPago: number,
    totalNotaCredito: number,
    totalDevolucion: number,
    pendiente: number,
    nuevoPendiente: number
};

export const obtenerCancelacionPreliminarGuarderia = async (idAgendamiento: string): Promise<CancelacionPreliminarGuarderia | undefined> => {
    return get<CancelacionPreliminarGuarderia>(`cancelaciones/guarderia/preliminar/?idAgendamiento=${idAgendamiento}`);
};

export const QUERY_OBTENER_CANCELACION_PRELIMINAR_GUARDERIA =
  "QUERY_OBTENER_CANCELACION_PRELIMINAR_GUARDERIA";

export type SolicitudCancelacionGuarderia = {
    idAgendamiento: string,
    notaCredito: { valor: number } | undefined,
    devolucion: { valor: number, metodo: MetodoPago } | undefined
}

export const cancelarGuarderia = async (solicitud: SolicitudCancelacionGuarderia): Promise<undefined> => {
  return post<SolicitudCancelacionGuarderia, undefined>("cancelaciones/guarderia", solicitud);
};

export type CancelacionPreliminarHotel = CancelacionPreliminarGuarderia;

export const obtenerCancelacionPreliminarHotel = async (idAgendamiento: string): Promise<CancelacionPreliminarGuarderia | undefined> => {
    return get<CancelacionPreliminarHotel>(`cancelaciones/hotel/preliminar?idAgendamiento=${idAgendamiento}`);
};

export const QUERY_OBTENER_CANCELACION_PRELIMINAR_HOTEL =
  "QUERY_OBTENER_CANCELACION_PRELIMINAR_HOTEL";

export type SolicitudCancelacionHotel = SolicitudCancelacionGuarderia;

export const cancelarHotel = async (solicitud: SolicitudCancelacionHotel): Promise<undefined> => {
  return post<SolicitudCancelacionHotel, undefined>("cancelaciones/hotel", solicitud);
};